<script setup lang="ts">
import { MessageCircle } from 'lucide-vue-next'
import { useChatStore } from '@/stores/chat'

const chatStore = useChatStore()
</script>

<template>
  <button
    @click="chatStore.toggle()"
    class="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-primary-600 hover:bg-primary-500 text-white shadow-lg transition-colors"
    title="Live Chat"
  >
    <MessageCircle class="w-6 h-6" />
    <span
      v-if="chatStore.unreadCount > 0"
      class="absolute -top-1 -right-1 flex items-center justify-center min-w-[20px] h-5 px-1 text-xs font-bold bg-danger-500 text-white rounded-full"
    >
      {{ chatStore.unreadCount > 99 ? '99+' : chatStore.unreadCount }}
    </span>
  </button>
</template>
